const getActualScreen = route => {
  switch (route) {
    case 'homeuser':
      return 'home inicio';
    case 'sapeliculas':
      return 'home peliculas';
    case 'home series':
      return 'home series';
    case 'ninios':
      return 'home kids';
    case 'micontenido':
      return 'home mis contenidos';
    case 'pandg_hbo':
      return 'home hbo';
    default:
      return `home ${route}`;
  }
};

export default getActualScreen;
